
import { Component } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import Tiptop from '@/components/headers/tiptop.vue';
import LanguageList from '@/components/language-list.vue';
import HeaderCommon from './header-common.vue';
import breadcrumbNav from '@/components/breadcrumb-nav.vue';
import Vendor from '@/store/entities/auth/Vendor';
import Util from '@/lib/util';

@Component({
  components: { Tiptop, LanguageList, HeaderCommon, breadcrumbNav },
  props: {
    hideBreadcrumb: Boolean
  }
})
export default class Header extends AbpBase {
  left: number = 0;
  currentMenuId: number = 0;
  vid: string = '';
  vendor: Vendor = new Vendor();
  ctg: string = '';

  get tenant() {
    return Util.abp.multiTenancy.getTenantCookie();
  }

  get isStandardEdition() {
    return Util.isStandardEdition();
  }

  get productionCount() {
    return this.$store.state.product.productionCount;
  }

  get navData() {
    return this.$store.state.productCategory.vendorProductCategoryList;
  }

  created() {
    if (this.$route.query.vid) {
      this.vid = this.$route.query.vid.toString();
    } else {
      this.$Modal.warning({
        title: this.L('Tips'),
        content: this.L('VendorDoesNotExists'),
        onOk: () => {
          history.go(-1)
        }
      })
    }

    if (this.$route.query.ctg) {
      this.ctg = this.$route.query.ctg.toString();
    }

    this.getVendor();
    this.getNavData();
    this.getProductionCount();
  }

  getNavData() {
    this.$store.dispatch({
      type: 'productCategory/getNavigationListByVendor',
      data: this.vid
    });
  }

  getVendor() {
    this.$store.dispatch({
      type: 'vendor/getByNo',
      data: this.vid
    }).then(data => {
      this.vendor = data as Vendor;

      if (!data.isActive) {
        this.$Modal.warning({
          title: this.L('Tips'),
          content: this.L('VendorIsNotActive'),
          onOk: () => {
            if (history.length == 1) {
              window.close();
            } else {
              history.go(-1);
            }
          }
        });
      }
    }).catch(err => {
      if (err.toString().indexOf('404') > -1) {
        this.$Modal.warning({
          title: this.L('SystemTips'),
          content: this.L('VendorDoesNotExists'),
          onOk: () => {
            history.go(-1);
          }
        });
      }
    });
  }

  getProductionCount() {
    this.$store.dispatch({
      type: 'product/getTotalCountByVendor',
      data: this.vid
    });
  }
}
